// Fit-to-width titles: size each heading inside `.njamito-section-title--fit`
// so its text spans the full container width. Pure CSS can't measure text, so
// we measure the real text width (via a Range) and scale the font-size to match.

function fitHeading(heading: HTMLElement, container: HTMLElement): void {
    const cs = window.getComputedStyle(container);
    const avail =
        container.clientWidth -
        parseFloat(cs.paddingLeft || '0') -
        parseFloat(cs.paddingRight || '0');

    if (avail <= 0) return;

    // Measure text width at a known reference size, then scale linearly.
    const REF = 100;
    heading.style.fontSize = `${REF}px`;

    const range = document.createRange();
    range.selectNodeContents(heading);
    const textWidth = range.getBoundingClientRect().width;

    if (textWidth > 0) {
        heading.style.fontSize = `${(REF * avail) / textWidth}px`;
    }
}

function fitAll(reveal = false): void {
    const containers = Array.from(
        document.querySelectorAll<HTMLElement>('.njamito-section-title--fit')
    );

    containers.forEach(container => {
        const headings = Array.from(
            container.querySelectorAll<HTMLElement>('h1, h2, h3, h4, h5, h6')
        );
        headings.forEach(h => fitHeading(h, container));
        // Reveal only once sizing is final, so the text never shows at the
        // wrong size (`.is-fit` drops the visibility:hidden guard).
        if (reveal) container.classList.add('is-fit');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.njamito-section-title--fit')) return;

    // Measure while hidden, then measure again + reveal once web fonts are ready
    // (the real face changes text metrics). A timeout guarantees the title never
    // stays hidden if fonts.ready stalls. Single visible paint.
    fitAll(false);
    const fontsReady =
        'fonts' in document
            ? (document as any).fonts.ready
            : Promise.resolve();
    const timeout = new Promise(resolve => setTimeout(resolve, 500));
    Promise.race([fontsReady, timeout]).then(() => fitAll(true));

    let raf = 0;
    window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => fitAll(false));
    });
});
